"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HUBSPOT_NAV_AFTER_ID = exports.HUBSPOT_NAV_BEFORE_ID = exports.HUBSPOT_NAV_NO_BOTTOM_MARGIN_CLASS = exports.HUBSPOT_NAV_V4_ID = exports.HUBSPOT_NAV_V3_ID = void 0;
var HUBSPOT_NAV_V3_ID = 'hs-nav-v3';
exports.HUBSPOT_NAV_V3_ID = HUBSPOT_NAV_V3_ID;
var HUBSPOT_NAV_V4_ID = 'hs-nav-v4';
exports.HUBSPOT_NAV_V4_ID = HUBSPOT_NAV_V4_ID;
var HUBSPOT_NAV_NO_BOTTOM_MARGIN_CLASS = 'no-bottom-margin';
exports.HUBSPOT_NAV_NO_BOTTOM_MARGIN_CLASS = HUBSPOT_NAV_NO_BOTTOM_MARGIN_CLASS;
var HUBSPOT_NAV_BEFORE_ID = 'hs-nav-before-container';
exports.HUBSPOT_NAV_BEFORE_ID = HUBSPOT_NAV_BEFORE_ID;
var HUBSPOT_NAV_AFTER_ID = 'hs-nav-after-container';
exports.HUBSPOT_NAV_AFTER_ID = HUBSPOT_NAV_AFTER_ID;